import React from 'react';
import PropTypes from 'prop-types';
import styles from './sticky-container.module.css';

export const StickyContainer = ({ children, style = {} }) => (
  <div className={styles.root} style={style}>
    {children}
  </div>
);

StickyContainer.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
};
